import React from 'react'
import ReactLogo from './pingone-privilege.svg'

const PingPrivilegeLogo = ({ className = '' }) => {
  if (!ReactLogo) return null
  return <img className={className} src={ReactLogo} />
}

export { PingPrivilegeLogo }
